module.exports = __webpack_public_path__ + "img/solution1.c4213d0f.png";